import { LegalDocumentDto } from '@model/CompanyLegalDocumentDto'

export const filterDocumentsByClient = (document: LegalDocumentDto): boolean => {
  return document.step === 'client'
}
